import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { SinglePropertyEconomicsCard } from '../singleProperty/singlePropertyEconomicsCard';
import { LoanTermsCard } from './loanTermsCard';
import { StepTitle } from './stepTitle';

interface LoanPricerStepProps {
  store: any;
}

export const LoanPricerStep = observer(({ store }: LoanPricerStepProps) => {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <StepTitle title={<>Loan Pricer</>} />
        </Grid>
        <Grid item xs={12}>
          <LoanTermsCard store={store} />
        </Grid>
        <Grid item xs={12}>
          <SinglePropertyEconomicsCard store={store} />
        </Grid>
      </Grid>
    </>
  );
});
